module.exports = __webpack_public_path__ + "static/img/bg1@2x.92302f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/bg1@2x.png
// module id = /XeB
// module chunks = 70